module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-9__39fcba6381263050d6408b2ba340f51b.png";